import React from 'react';
export function SectionLabel({
  number,
  label
}: {
  number: string;
  label: string;
}) {
  return <div className="flex items-center gap-3 mb-6" data-id="element-144">
      <span className="font-display italic text-2xl text-brand-teal" data-id="element-145">
        {number}
      </span>
      <span className="h-px flex-1 max-w-[60px] bg-surface-border" data-id="element-146" />
      <span className="text-xs font-semibold tracking-[0.2em] uppercase text-ink-muted" data-id="element-147">
        {label}
      </span>
    </div>;
}